import { useMemo } from "react";
import { StackProps } from "@mui/material";

import { apiGetBottomItems, apiGetSidebarItems } from "services/api/item";
import useGetData from "hooks/useGetData";
import { ItemList } from "Components";
import { useIntl } from "react-intl";
import useMediaBreakpoints from "hooks/useMediaBreakpoints";
import { useParams } from "react-router-dom";
import Card from "Components/card/Card";

const BottomItems = (props: StackProps) => {
  const { downTabletBreakpoint: isMobile } = useMediaBreakpoints();
  const intl = useIntl();
  const { itemId } = useParams<{ itemId: string }>();
  const { isLoading, data: bottomItemsData } = useGetData({
    promise: () => apiGetBottomItems({ farm_item: itemId }),
    deps: [itemId],
  });
  const { data: suggestedItemsData } = useGetData({
    promise: () => {
      if (isMobile) return apiGetSidebarItems({ farm_item: itemId });
      return;
    },
    deps: [itemId, isMobile],
  });
  const suggestedItems = useMemo(
    () => suggestedItemsData?.data?.suggested_items || [],
    [suggestedItemsData]
  );
  const bottomItems = useMemo(() => bottomItemsData?.data, [bottomItemsData]);

  const customBreakpoints = {
    300: {
      slidesPerView: 2,
      spaceBetween: 8,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 8,
    },
    1440: {
      slidesPerView: 5,
      spaceBetween: 8,
    },
  };

  return (
    <Card spacing={{ xs: 1, md: 2 }} {...props}>
      {(bottomItems?.recommendation_items || []).length > 0 && (
        <ItemList
          itemList={bottomItems?.recommendation_items}
          itemListLabel={intl.formatMessage({
            id: "related_products_for_you",
          })}
          isLoading={isLoading}
          hasViewAll={false}
          breakpoints={customBreakpoints}
        />
      )}
      {(bottomItems?.from_supplier_items || []).length > 0 && (
        <ItemList
          itemList={bottomItems?.from_supplier_items}
          itemListLabel={intl.formatMessage({
            id: "supplier_products",
          })}
          hasViewAll={false}
          breakpoints={customBreakpoints}
        />
      )}
      {isMobile && suggestedItems.length > 0 && (
        <ItemList
          itemList={suggestedItems}
          itemListLabel={intl.formatMessage({
            id: "sponsor_products",
          })}
          hasViewAll={false}
          breakpoints={customBreakpoints}
        />
      )}
    </Card>
  );
};

export default BottomItems;
